export const name = "VARIANCE";
export const summary = `An alias of \`VAR_SAMP\`.`;
export const reference = `
## VARIANCE

An alias of \`VAR_SAMP\`.

\`\`\`
VARIANCE(
  [DISTINCT]
  expression
)
[OVER over_clause]

over_clause:
  { named_window | ( [window_specification] ) }

window_specification:
  [named_window]
  [PARTITION BY partition_expression [, ...] ]
  [ORDER BY expression [ { ASC | DESC }] [, ...] ]
  [window_frame_clause]
\`\`\`

### Description

An alias of VAR_SAMP.




source: https://cloud.google.com/bigquery/docs/reference/standard-sql/statistical_aggregate_functions
`;
